import React, { useState, useEffect } from 'react'
import config from 'config'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NoticeboardDashbard from './NoticeboardDashbard/NoticeboardDashbard';
import NoticeboardAPICall from 'NoticeboardAPICall';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import RouteMenu from 'NOTICEBOARD/CommonResources/RoutingMenu/RouteMenu';
import 'NOTICEBOARD/Components/noticeboard.css';

let accessApiPath = '/api/instructor/noticeboard.php';

function NoticeBoard() {

    useEffect(() => {
        // apiCallToGetAccessDetails()
    }, []);
    const [adminData, setAdminData] = useState([]);

    const [manageNoticeAccess, setManageNoticeAccess] = useState({});
    const [manageCategoryAccess, setManageCategoryAccess] = useState({});
    const [isNoticeBoardAdmin, setIsNoticeAdmin] = useState(false);
    const [isCategoryAdmin, setIsCategoryAdmin] = useState(false);

    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });

    const apiCallToGetAccessDetails = async () => {
        let requestData = {
            institute_id: config.institute_id,
            user_id: config.faculty_id,
            stream_id: config.stream_id
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'GetNoticeBoardAccessDetails',
            requestData,
            accessApiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetAccessDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.access_provided;
                setAdminData(apiResult.admin.accessGrantedTo)

                // setIsCategoryAdmin(apiResult.manage_notice.isAccessGranted == 'false' ? false : true);
                setManageNoticeAccess(apiResult.manage_notice.accessGrantedTo);
                // setManageCategoryAccess(apiResult.manage_notice_category.accessGrantedTo);
                setIsNoticeAdmin(apiResult.manage_notice.isAccessGranted == 'false' ? false : true);

            }
        }
    }


    // METHOD TO VIEW WARNING
    const viewWarning = () => {
        if (manageNoticeAccess.length > 0) {
            let adminNames = [];
            manageNoticeAccess.map(access => {
                adminNames.push(access.name);
            });

            setSuccessModalDetails({
                successModal: true,
                successModalType: 'warning',
                successMessage: `Access granted to  ${adminNames.join(', ')}.`
            });
        } else {
            let noticeAccess = [];
            adminData &&
                Object.values(adminData).map(access => {
                    noticeAccess.push(access.adminName);
                });
            setSuccessModalDetails({
                successModal: true,
                successModalType: "warning",
                successMessage: 'Access is not granted to anyone. Please contact ' + noticeAccess.toString() + ' for more details.'
            });
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        });
    }

    return (
        // ROUTING LINKS FOR NOTICE BOARD DASHBOARD 
        <>
            <div className="sideMenu" style={{ padding: 0 }}>
                <RouteMenu activeScreen="notices" />
            </div>
            <div className="noticeComponents" style={{ alignItems:"center", backgroundColor:'#F4F4F4' }}>
                <div className="row">
                    <div className="NoticeboardComponent-header col-md-6">
                        <h4>Notices</h4>
                    </div>
                
                    <div className="col-md-6" style={{ display:'flex',alignItems:"center",justifyContent:"flex-end" }}>
                        {/* MANAGE NOTICE ASSIGN ACCESS LINK BUTTON  */}
                        <div className='oldNotice'>
                            <a href={`${config.RootUrl}/faculty/noticeboard/notice.php`}>(Old Noticeboard)</a>
                        </div>
                    </div>
                </div>
                {/* RENDER NOTICE BOARD DASHBOARD COMPONENT */}
                <NoticeboardDashbard />
            </div>

            {/* SUCCESS MODAL FOR NOTICE BOARD  */}
            {
                successModalDetails.successModal &&
                    <SuccessModal
                        successModal={successModalDetails.successModal}
                        successModalType={successModalDetails.successModalType}
                        successMessage={successModalDetails.successMessage}
                        closeSuccessModal={closeSuccessModal}
                    />
            }
        </>
    )
}

export default NoticeBoard
